module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pensionInfoTable":"Pension Info"},"si":{"pensionInfoTable":"Pension Info"},"ta":{"pensionInfoTable":"Pension Info"}}')
  delete Component.options._Ctor
}
